import { Form, Input, Select, TableColumnsType, Tag } from "antd"
import { TOnChangeInTable } from "../../../../../../../components/custom/customDynamicTable"
import { useEffect } from "react"

interface IProps {
    idx: number;
    onChangeInTable: TOnChangeInTable<IEditProgramSubjectOption>;
}

const IndexCell: React.FC<IProps> = ({ idx, onChangeInTable }) => {
    useEffect(() => {
        if (!idx || !onChangeInTable) return
        onChangeInTable(idx, 'idx', idx);
    }, []);
    return <>
        {idx + 1}
    </>
};

const getProgramSelectColumns = (onChangeInTable: TOnChangeInTable<IEditProgramSelectOption>): TableColumnsType<IEditProgramSelectOption> => [
    {
        title: '순서',
        dataIndex: 'idx',
        width: '10%',
        render: (value: number, _record, idx) => <IndexCell idx={value ?? idx} onChangeInTable={onChangeInTable} />
    },
    {
        title: '답변 필수/선택',
        dataIndex: 'isRequired',
        width: '15%',
        render: (value: boolean, record, idx) => <Select onChange={q => onChangeInTable(idx, 'isRequired', q)} defaultValue={value ?? true} disabled={!record.isEdit} options={[{ label: '필수', value: true, }, { label: '선택', value: false }]} />
    },
    {
        title: '옵션명',
        dataIndex: 'name',
        width: '15%',
        render: (value: string, record, idx) => <>
            {record.isEdit
                ? <Input defaultValue={value ?? ''} onChange={q => onChangeInTable(idx, 'name', q.target.value)} />
                : <div style={{ paddingInline: '11px', paddingBlock: '5px', marginLeft: '1px' }}>{value}</div>}
        </>
    },
    {
        title: '옵션설명',
        dataIndex: 'description',
        width: '15%',
        render: (value: string, record, idx) => <>
            {record.isEdit
                ? <Input defaultValue={value} onChange={q => onChangeInTable(idx, 'description', q.target.value)} />
                : <div style={{ paddingInline: '11px', paddingBlock: '5px', marginLeft: '1px' }}>{value}</div>}
        </>
    },
    {
        title: '옵션 종류',
        dataIndex: 'programSelectOptionItemList',
        width: '35%',
        render: (value: IProgramSelectOptionItem[], record, idx) => {
            return <>
                {record.isEdit
                    ? <Input placeholder="쉼표(,)로 옵션 분리" defaultValue={value?.map((q: IProgramSelectOptionItem) => q.name) ?? ''} onChange={w => onChangeInTable(idx, 'programSelectOptionItemList', w.target.value.split(',').map((e, index) => ({ id: Math.max(...value.map(r => r.id ?? 0), 0) + index + 1, name: e.trim() })))} />
                    : <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.isBooking !== currentValues.isBooking}>
                        {({ getFieldValue }) =>
                            <div style={{ paddingInline: '11px', paddingBlock: '5px', marginLeft: '1px' }}>{value?.map((q: IProgramSelectOptionItem) => <Tag key={q.id} closable={typeof record.id === 'number' || !getFieldValue('isBooking')} onClose={_ => onChangeInTable(idx, 'programSelectOptionItemList', value?.filter(e => e.id !== q.id), true)}>{q.name}</Tag>)}</div>
                        }
                    </Form.Item>
                }
            </>
        }
    },
]

const getProgramSubjectColumns = (onChangeInTable: TOnChangeInTable<IEditProgramSubjectOption>): TableColumnsType<IEditProgramSubjectOption> => [
    {
        title: '순서',
        dataIndex: 'idx',
        width: '10%',
        render: (value: number, _record, idx) => <IndexCell idx={value ?? idx} onChangeInTable={onChangeInTable} />
    },
    {
        title: '답변 필수/선택',
        dataIndex: 'isRequired',
        width: '15%',
        render: (value: boolean, record, idx) => <Select onChange={q => onChangeInTable(idx, 'isRequired', q)} defaultValue={value ?? true} disabled={!record.isEdit} options={[{ label: '필수', value: true, }, { label: '선택', value: false }]} />
    },
    {
        title: '옵션명',
        dataIndex: 'name',
        width: '15%',
        render: (value: string, record, idx) => <>
            {record.isEdit
                ? <Input defaultValue={value} onChange={q => onChangeInTable(idx, 'name', q.target.value)} />
                : <div style={{ paddingInline: '11px', paddingBlock: '5px', marginLeft: '1px' }}>{value}</div>}
        </>
    },
    {
        title: '옵션설명',
        dataIndex: 'description',
        width: '35%',
        render: (value: string, record, idx) => <>
            {record.isEdit
                ? <Input defaultValue={value} onChange={q => onChangeInTable(idx, 'description', q.target.value)} />
                : <div style={{ paddingInline: '11px', paddingBlock: '5px', marginLeft: '1px' }}>{value}</div>}
        </>
    },
]

export { getProgramSelectColumns, getProgramSubjectColumns }